import { ApiV2Response, nzApiClient } from '@nizza/core';
import { omit } from 'ramda';
import { ProductParamsInput, ProductREST, createProduct } from '../../utils';
import { Product, ProductRepository } from '../domain';

export class ProductRestRepository implements ProductRepository {
  account!: string;

  async find(id: string): Promise<Product | null> {
    const { data } = await nzApiClient.rest<ApiV2Response<ProductREST>>({
      path: `/v1/product/${id}`,
      queryParams: { account: this.account },
    });

    return createProduct(data);
  }

  async search(input: ProductParamsInput = {}): Promise<Product[]> {
    const path = input.search ? `/v1/product/search` : `/v1/product`;

    const queryParams = {
      ...input,
      account: this.account,
    };

    const { data, isArray } = await nzApiClient.rest<
      ApiV2Response<ProductREST[]>
    >({
      path,
      queryParams,
      secure: true,
      account: this.account,
    });

    if (!isArray || !data) return [];

    return data.map(x => createProduct(x));
  }

  async create(product: Product) {
    const body = omit(['id', 'createdAt'], product.toPrimitives());

    await nzApiClient.rest<ApiV2Response<void>>({
      path: `/v1/product`,
      method: 'POST',
      body,
      secure: true,
      account: this.account,
    });
  }

  async update(product: Product) {
    const body = omit(['createdAt', 'id'], product.toPrimitives());

    await nzApiClient.rest<ApiV2Response<void>>({
      path: `/v1/product/${product.id}`,
      method: 'PUT',
      body,
      secure: true,
      account: this.account,
    });
  }

  async delete(id: string) {
    await nzApiClient.rest<ApiV2Response<void>>({
      path: `/v1/product/${id}`,
      queryParams: { account: this.account },
      method: 'DELETE',
      secure: true,
      account: this.account,
    });
  }
}
